
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    ViewEncapsulation
} from '@angular/core';
import { VisualField } from 'src/app/pbir/visuals/VisualField';
import { VisualFieldTarget } from 'src/app/pbir/visuals/VisualFieldTarget';
import { DataCurrencyLayout, DataCurrencySign, DataNumberFormat } from 'src/app/services/api.services';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'visual-editor-field-icons',
  template: `
    @let f = field();

    <div class="d-inline-flex align-items-center">
      <div [hidden]="!f.isUDF" class="mx-3 d-inline math-font p-relative ot-1" title="User Defined Field">
        <span class="fs-11 bold">UDF</span>
      </div>

      <div [hidden]="!f.isAggregated" class="mx-3 d-inline p-relative ot-1" [title]="f.measureTitle">
        <i class="far fa-sigma i-12"></i>
      </div>

      <ng-content select="[beforeDataTypeIcon]"></ng-content>

      @if (isCurrency()) {
        <div class="ml-4 w-12 d-inline" [title]="'Currency ' + f.dataType.title">
          <i class="fas fa-dollar-sign i-11 p-relative ol-2"></i>
        </div>
      }
      @else {
        <div class="ml-4 w-12 d-inline" [title]="f.dataType.title">
          <i class="{{f.dataType.icon}}"></i>
        </div>
      }
      <ng-content select="[afterDataTypeIcon]"></ng-content>
    </div>
  `,
  styles: [`
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class.d-contents]': 'true'
  },
  standalone: true,
  imports: [SharedModule]
})
export class VisualEditorFieldIconsComponent {
  readonly field = input.required<VisualField | VisualFieldTarget>();
  readonly isCurrency = computed(() => this.field()?.dataType.isNumeric
                                    && this.field().dataDisplay?.numberFormat == DataNumberFormat.Currency);
}
